<div class="page-container ig-container-fluid">
    <router-outlet #outlet></router-outlet>

    <ig-row [pinRight]="true">
        <ig-col [xs]="1">
            <ig-button class="logout-btn" (trigger)="logout()">Logout</ig-button>
        </ig-col>
    </ig-row>

    <div class="scheduler relative">
        <ig-row>
            <h3>Scheduler, execute for </h3>
            <ig-drop-down ngClass="event-btn" showDropDownItem="true">
                <ig-drop-down-trigger [text]="accountName||'All Accounts'">
                    <!--EVENTS-->
                </ig-drop-down-trigger>
                <div items>
                    <ig-drop-down-item (click)="setAccount(null)">All Accounts</ig-drop-down-item>
                    <ig-drop-down-item *ngFor="let account of accounts" (click)="setAccount(account)">
                        {{account.userName}}
                    </ig-drop-down-item>
                </div>
            </ig-drop-down>
            <h3>source</h3>
            <ig-drop-down ngClass="event-btn" style="width:145px" showDropDownItem="true">
                <ig-drop-down-trigger [text]="eventSource">
                </ig-drop-down-trigger>
                <div items>
                    <ig-drop-down-item (click)="setSource('all')">All</ig-drop-down-item>
                    <ig-drop-down-item (click)="setSource('facebook')">facebook</ig-drop-down-item>
                    <ig-drop-down-item (click)="setSource('eventbrite')">eventbrite</ig-drop-down-item>
                    <!--                    <ig-drop-down-item (click)="setSource('eventful')">eventful</ig-drop-down-item>-->
                    <ig-drop-down-item (click)="setSource('serp|google')">serp|google</ig-drop-down-item>
                </div>
            </ig-drop-down>

            <ig-button *ngIf="isShowRemoveOutdatedEventsBtn" style="margin-left: 24px"
                (trigger)="deleteOutDatedEvents()">remove out dated events
            </ig-button>

            <form ngForm="codeFormGroup" class="hide-form">
                <ig-field [formControl]="codeFormGroup.get('code')" [(ngModel)]="code" (keyup)="checkCode()">
                </ig-field>
                <ig-field *ngIf="isShowUpdatePlaceBtn" label="id" [formControl]="codeFormGroup.get('identifier')"
                    [(ngModel)]="identifier">
                </ig-field>
                <ig-field *ngIf="isShowUpdatePlaceBtn" label="token" [formControl]="codeFormGroup.get('token')"
                    [(ngModel)]="token">
                </ig-field>

                <ig-field *ngIf="isShowFromTo||isShowEventbritePlaceId" [isInnerLabel]="true"
                    [label]="isShowFromTo?'from':'Eventbrite Event Page'" [formControl]="codeFormGroup.get('from')"
                    [(ngModel)]="from">
                </ig-field>
                <ig-field *ngIf="isShowFromTo||isShowEventbritePlaceId" [isInnerLabel]="true"
                    [label]="isShowFromTo?'to':'Eventbrite Place Id'" [formControl]="codeFormGroup.get('to')"
                    [(ngModel)]="to">
                </ig-field>
                <ig-button *ngIf="isShowEventbritePlaceId" [isAsync]="true"
                    (trigger)="addEventbritePlaceId($event)">Add</ig-button>
                <ig-button *ngIf="isShowUpdateAllowedCover" [isAsync]="true" (trigger)="updatePlaceCover($event)">Update
                    Place Cover</ig-button>
            </form>
        </ig-row>

        <ng-container *ngIf="!isEventPuller">
            <div class="btn-group">
                <ig-button [disabled]="isSchedulerRunning" (trigger)="synceData()">
                    {{isSchedulerRunning ? 'Running...' : 'Sync data for selected account and source'}}
                </ig-button>

                <ig-button (trigger)="updateMultiDateEvents()">
                    {{isSchedulerRunning ? 'Running...' : 'Update Multi-Date Events'}}
                </ig-button>

                <ig-button [disabled]="isSchedulerRunning" (trigger)="getLatAndLngFromGoogleForMissingAddressEvents()">
                    {{isSchedulerRunning ? 'Running...' : 'Add Missing Address for events'}}
                </ig-button>

            </div>

            <div class="btn-group">
                <ig-button (trigger)="travelBuddyConversations()">
                    <img src="https://iti-images.s3.amazonaws.com/imgs/ai-star.gif" class="m-r-1" width="22px"
                        height="22px">Travel Buddy Conversations
                </ig-button>

                <ig-button [disabled]="isSchedulerRunning" (trigger)="updatePlaces()">
                    {{isSchedulerRunning ? 'Running...' : 'Update Google Places'}}
                </ig-button>

                <!--<ig-row *ngIf="isShowUpdatePlaceBtn">-->
                <!--<ig-col [xs]="6">-->
                <!--<ig-button [disabled]="isSchedulerRunning"-->
                <!--(trigger)="updatePlaces()">-->
                <!--{{isSchedulerRunning ? 'Running...' : 'Update Places'}}-->
                <!--</ig-button>-->
                <!--</ig-col>-->
                <!--<ig-col [xs]="6">-->
                <!--<ig-button [disabled]="isSchedulerRunning"-->
                <!--(trigger)="updatePlaceByFBId()">-->
                <!--{{isSchedulerRunning ? 'Updating for ' + identifier : 'Update Place By FB ID'}}-->
                <!--</ig-button>-->
                <!--</ig-col>-->
                <!--</ig-row>-->

                <ig-button [disabled]="isSchedulerRunning" (trigger)="removeDuplicatedPlaces()">
                    {{isSchedulerRunning ? 'Running...' : 'Remove Duplicated Places'}}
                </ig-button>
            </div>

            <div class="btn-group">
                <ig-button [disabled]="isSchedulerRunning" (trigger)="updatePlacesForNext()">
                    {{isSchedulerRunning ? 'Running...' : 'Update FB Place For Next'}}
                </ig-button>
                <ig-button [disabled]="isSchedulerRunning" (trigger)="filterUnofficialPlaces()">
                    {{isSchedulerRunning ? 'Running...' : 'Filter Unofficial Places'}}
                </ig-button>

                <ig-button [disabled]="isSchedulerRunning" (trigger)="runEventbriteConjob()">
                    {{isSchedulerRunning ? 'Running...' : 'Run Eventbrite Cronjob'}}
                </ig-button>
                <ig-button [disabled]="isSchedulerRunning" (trigger)="eventPullingStatus()">
                    {{isSchedulerRunning ? 'Running...' : 'Event Pulling Status'}}
                </ig-button>
            </div>
        </ng-container>

        <div class="flex m-t-2">
            <mat-icon *ngIf="!loading" matTooltip="Load saved pages" style="margin:13px 8px 0 0"
                (click)="loadSpiderPages()">autorenew
            </mat-icon>
            <ig-spinner *ngIf="loading"></ig-spinner>
            <div *ngIf="!isUseLinks" style="width:75%">
                <mat-checkbox *ngFor="let page of fbPages" style="margin-left: 24px" [(ngModel)]="page.checked">
                    {{page.url.replace('www.','') + (page.tag ? ' (' + page.tag + ')' : '')}}
                </mat-checkbox>
            </div>
            <ig-field *ngIf="isUseLinks" #field label="spider link" style="width:75%" [isInnerLabel]="true"
                [formControl]="codeFormGroup.get('spider')" icon="search" [label]="spiderTip" [(ngModel)]="spiderLink">
            </ig-field>
            <div class="p-l-3">
                <mat-checkbox style="display: block" [ngStyle]="{'padding-top':isShowUseLinkChk?'0':'9px'}"
                    [(ngModel)]="isSpiderUseProxy">Use Proxy
                </mat-checkbox>

                <mat-checkbox style="display: block" [(ngModel)]="isUseCityCode">Use
                    City Code Search (Eventbrite)
                </mat-checkbox>
                <mat-checkbox *ngIf="isUseCityCode" style="display: block"
                    [(ngModel)]="isUseCityCodeAPIOnEventbriteHomepage">New City Code Search (Eventbrite)
                </mat-checkbox>

                <mat-checkbox *ngIf="isShowUseLinkChk" style="display: block"
                    [ngStyle]="{'padding-top':isShowUseLinkChk?'0':'9px'}" [(ngModel)]="isUseLinks">Input Links
                </mat-checkbox>

                <!--                /**-->
                <!--                * for some small cities, pull 20 pages may still cannot get too many events after filtering by city-->
                <!--                * so we can pull more pages-->
                <!--                * useGatherEventsInCityBeforeStop === true means to launch this logic-->
                <!--                * gatherNumberOfEventsInCityBeforeStop is how many events you want to gather-->
                <!--                * maxTryingPages sets a max pages to pull, even if not enough events gathered-->
                <!--                */-->
                <div>
                    <mat-checkbox *ngIf="eventSource.indexOf('serp|google') >= 0" style="display: block"
                        [ngStyle]="{'padding-top':isShowUseLinkChk?'0':'9px'}"
                        [(ngModel)]="serpGoogleConfig.useGatherEventsInCityBeforeStop">Search more pages until get
                        enough events in city?
                    </mat-checkbox>

                    <div *ngIf="serpGoogleConfig.useGatherEventsInCityBeforeStop" class="m-t-2">
                        <ig-field label="Number of events to gather before stop"
                            [formControl]="codeFormGroup.get('gatherNumber')" icon="search"
                            [(ngModel)]="serpGoogleConfig.gatherNumberOfEventsInCityBeforeStop">
                        </ig-field>
                        <ig-field label="Max number of pages (force stop pulling)"
                            [formControl]="codeFormGroup.get('maxPages')" icon="search"
                            [(ngModel)]="serpGoogleConfig.maxTryingPages">
                        </ig-field>
                    </div>
                </div>
            </div>
            <ig-button style="height:36px;margin: 4px 0 0 16px" (trigger)="spider($event)"
                [disabled]="isSchedulerRunning" size="md">{{isSchedulerRunning ? 'Running...' : 'pull events'}}
            </ig-button>
            <ig-button style="height:36px;margin: 4px 0 0 16px" (trigger)="getFBPulledEvents($event)" [isAsync]="true"
                size="md">saving events popup
            </ig-button>
            <ig-button style="height:36px;margin: 4px 0 0 16px;min-width: 60px" (trigger)="stopPullingEvents($event)"
                [isAsync]="true" size="md">stop
            </ig-button>
        </div>

        <div class="reports" #reportsContainer>

            <div *ngFor="let report of schedulerProgressReports" [style.color]="report.color"
                [innerHTML]="report.message">
                <!-- {{report.message}} -->
            </div>
        </div>

        <span style="position: absolute;right: 16px; bottom: 20px;cursor: pointer" (click)="clearReport()">clear</span>
        <div style="position:absolute;bottom:20px; right:76px">
            <mat-checkbox style="display: block" [(ngModel)]="isAutoScrolling">Auto scrolling
            </mat-checkbox>
        </div>

    </div>
</div>


// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/admin/admin.component.html